export const TODO_NOTE_EXPIRED_DOCUMENT = 'The document provided has expired.';
export const TODO_NOTE_EXPIRING_DOCUMENT = 'The document provided will expire within 30 days.';
